<template>
    <ModalComponent
        :name='"pagar-plazo-" + plazo_id'
        title="Pagar plazo"
        v-on:close="close"
    >
        <div v-if="!loading">
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <PagoComponent :importe="importe" @terminado="submit" @close="close()"/>
            </ValidationObserver>
        </div>
        <LoaderComponent v-else/>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import PagoComponent from "./PagoComponent";

    export default {
        props: ['plazo_id', 'importe'],
        data() {
            return {
                metodo_pago: null,
                loading: false
            }
        },
        methods: {
            close() {
                this.$emit('close', 'pagar-plazo-' + this.plazo_id);
            },
            pagarPlazo() {
                this.$emit('terminado', this.metodo_pago, this.plazo_id);
            },
            async submit(metodo_pago) {
                this.metodo_pago = metodo_pago;

                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.pagarPlazo();
                }
            }
        },
        components: { ModalComponent, PagoComponent }
    }
</script>